import { FormattedMessage } from 'react-intl';
import { generatePath, useLocation, useNavigate, useParams, type NavigateOptions } from 'react-router-dom-v5-compat';

import config from '@/config';
import { Button } from '@/modules/ui';

const navigateOptions = { replace: true } satisfies NavigateOptions;

export const CancelButton = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { id } = useParams();

    const handleClick = () => {
        if (state?.from) {
            navigate(state.from, navigateOptions);
        } else if (id) {
            navigate(generatePath(config.routes.secret, { id }), navigateOptions);
        } else {
            navigate(config.routes.secrets, navigateOptions);
        }
    };

    return (
        <Button size='large' onClick={handleClick} type='text'>
            <FormattedMessage id='cancel' />
        </Button>
    );
};
